export default __webpack_public_path__ + "static/media/baner.6014c581.png";